import { v4 } from 'uuid';
import { StaticNode } from '../type';
import { dropAsyncValidatorMock, dropSyncValidatorMock } from './validators';
import { html, TemplateResult } from 'lit';

export const rootNodes = {
  currentNode: {
    nodeId: 'bitdefender',
    nodeName: 'Bitdefender',
    isOpen: true,
    icon: 'ds-icon-containers',
    dropValidators: [dropSyncValidatorMock, dropAsyncValidatorMock],
  },
  childNodes: [
    {
      nodeId: 'test-1',
      nodeName: 'Test 1',
      icon: 'ds-icon-MacOS',
      dropValidators: [dropSyncValidatorMock, dropAsyncValidatorMock],
    },
    {
      nodeId: 'test-2',
      nodeName: 'Test 2',
      icon: 'ds-icon-menu_network',
      dropValidators: [dropSyncValidatorMock, dropAsyncValidatorMock],
    },
  ],
};

export const additionalStaticNodes: Array<StaticNode> = [
  ...Array.from({ length: 10 }, (_, i) => ({
    nodeId: `static-node-${i + 1}`,
    nodeName: `Node ${i + 1}`,
    childNodes: Array.from({ length: 5 }, (_, j) => ({
      nodeId: `static-node-${i + 1}-child-${j + 1}`,
      nodeName: `Node ${i + 1} - Child ${j + 1}`,
    })),
  })),
];

export const staticNodes: Array<StaticNode> = [
  {
    nodeId: 'bitdefender',
    nodeName: 'Bitdefender',
    isOpen: true,
    icon: 'ds-icon-containers',
    childNodes: [
      ...additionalStaticNodes,
      {
        nodeId: 'test-1-id',
        nodeName: 'Test 1',
        icon: 'ds-icon-MacOS',
        childNodes: [
          {
            nodeId: 'test-1-1-id',
            nodeName: 'Test 1 - 1',
            icon: 'ds-icon-menu_network',
          },
          {
            nodeId: 'test-1-2-id',
            nodeName: 'Test 1 - 2',
            icon: 'ds-icon-menu_network',
          },
        ],
      },
      {
        nodeId: 'test-2-id',
        nodeName: 'Test 2',
        icon: 'ds-icon-menu_network',
        childNodes: [
          {
            nodeId: 'test-2-1-id',
            nodeName: 'Test 2 - 1',
            icon: 'ds-icon-menu_network',
          },
          {
            nodeId: 'test-2-2-id',
            nodeName: 'Test 2 - 2',
            icon: 'ds-icon-menu_network',
          },
        ],
      },
    ],
  },
];

const customIconRenderer = (tooltipText: string): TemplateResult => {
  return html`
    <gz-tooltip tooltipText="${tooltipText}">
      <gz-icon name="ds-icon-notification_warning" size="20" color="var(--orange-alert-chart-100)"></gz-icon>
    </gz-tooltip>
  `;
};
export const staticNodesWithCustomIcon: Array<StaticNode> = [
  {
    nodeId: 'bitdefender',
    nodeName: 'Bitdefender',
    isOpen: true,
    icon: 'ds-icon-containers',
    childNodes: [
      {
        nodeId: v4(),
        nodeName: 'Test 1',
        icon: 'ds-icon-MacOS',
        namePrefixRenderer: () => customIconRenderer('Tooltip text for icon'),
        childNodes: [
          {
            nodeId: v4(),
            nodeName: 'Test 1 - 1',
            icon: 'ds-icon-menu_network',
          },
          {
            nodeId: v4(),
            nodeName: 'Test 1 - 2',
            icon: 'ds-icon-menu_network',
          },
        ],
      },
      {
        nodeId: v4(),
        nodeName: 'Test 2',
        icon: 'ds-icon-menu_network',
        childNodes: [
          {
            nodeId: v4(),
            nodeName: 'Test 2 - 1',
            icon: 'ds-icon-menu_network',
          },
          {
            nodeId: v4(),
            nodeName: 'Test 2 - 2',
            icon: 'ds-icon-menu_network',
          },
        ],
      },
    ],
  },
];

export const dynamicRootNodesNoIcons = {
  currentNode: {
    nodeId: 'bitdefender',
    nodeName: 'Bitdefender',
    isOpen: true,
  },
  childNodes: [
    {
      nodeId: 'test-1',
      nodeName: 'Test 1',
    },
    {
      nodeId: 'test-2',
      nodeName: 'Test 2',
    },
  ],
};

export const staticNodesNoIcons: Array<StaticNode> = [
  {
    nodeId: 'bitdefender',
    nodeName: 'Bitdefender',
    isOpen: true,
    childNodes: [
      {
        nodeId: v4(),
        nodeName: 'Test 1',
        childNodes: [
          {
            nodeId: v4(),
            nodeName: 'Test 1 - 1',
          },
          {
            nodeId: v4(),
            nodeName: 'Test 1 - 2',
          },
        ],
      },
      {
        nodeId: v4(),
        nodeName: 'Test 2',
        childNodes: [
          {
            nodeId: v4(),
            nodeName: 'Test 2 - 1',
            childNodes: [
              {
                nodeId: v4(),
                nodeName: 'Test 2-2-1',
                childNodes: [
                  {
                    nodeId: v4(),
                    nodeName: 'Test 2-3-1',
                  },
                  {
                    nodeId: v4(),
                    nodeName: 'Test 2-3-2',
                  },
                ],
              },
            ],
          },
          {
            nodeId: v4(),
            nodeName: 'Test 2 - 2',
          },
        ],
      },
    ],
  },
];

export const staticNodesForNavigation: Array<StaticNode> = [
  {
    ...rootNodes.childNodes[1],
    childNodes: [
      {
        nodeId: 'test-2-2',
        nodeName: 'Test 2 - 2',
        icon: 'ds-icon-menu_network',
        dropValidators: [dropSyncValidatorMock, dropAsyncValidatorMock],
        childNodes: [
          {
            nodeId: 'test-3-1',
            nodeName: 'Test 3 - 1',
            icon: 'ds-icon-menu_network',
            dropValidators: [dropSyncValidatorMock, dropAsyncValidatorMock],
          },
        ],
      },
    ],
  },
];

export const dynamicNodesNoIcons = [
  {
    key: 'bitdefender',
    value: {
      nodeId: 'bitdefender',
      nodeName: 'Bitdefender',
      childNodeIds: ['test-1', 'test-2'],
    },
  },
  {
    key: 'test-1',
    value: {
      nodeId: 'test-1',
      nodeName: 'Test 1',
      parentNodeId: 'bitdefender',
      parentName: 'Bitdefender',
      childNodeIds: [
        'f2fadd68-87f6-468e-b3fa-5fc7bb1bbae2',
        '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
        '28303b05-b7d1-4155-a45c-6307c2b4ccc1',
      ],
    },
  },
  {
    key: 'test-2',
    value: {
      nodeId: 'test-2',
      nodeName: 'Test 2',
      parentNodeId: 'bitdefender',
      parentName: 'Bitdefender',
      childNodeIds: ['3ca3a8f7-e538-44f1-95c4-233458450aaf'],
    },
  },
  {
    key: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
    value: {
      nodeId: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      nodeName: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      parentNodeId: 'test-2',
      parentName: 'Test 2',
      childNodeIds: [
        '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
        '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
        '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
        '28474c55-5885-438a-b79c-da578f28f7ab',
      ],
    },
  },
  {
    key: '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
    value: {
      nodeId: '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
      nodeName: '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
      parentNodeId: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      parentName: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      childNodeIds: [
        '39831087-3534-48ad-8bd9-7962eb6294d8',
        'aa582975-6261-4c0a-b145-5a6ccbab182b',
        '5cf7e563-c132-4671-a878-b5b38100fc72',
      ],
    },
  },
  {
    key: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
    value: {
      nodeId: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
      nodeName: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
      parentNodeId: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      parentName: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      childNodeIds: [
        'c32f8ead-f3ff-4331-ac05-961e7c926e4e',
        '1bd0212f-a53a-4908-853a-c369a4d1fac4',
        'd1db0887-ba1c-4294-b096-76c721a6fec0',
      ],
    },
  },
  {
    key: '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
    value: {
      nodeId: '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
      nodeName: '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
      parentNodeId: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      parentName: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      childNodeIds: [
        '1db7ea52-303d-4174-b58a-10ab171c4bc4',
        '3c3c1e59-6988-4384-8a1b-23a0f0a17403',
        'caea1a5f-8c25-4c2a-8d76-21de4ea2bb6d',
      ],
    },
  },
  {
    key: '28474c55-5885-438a-b79c-da578f28f7ab',
    value: {
      nodeId: '28474c55-5885-438a-b79c-da578f28f7ab',
      nodeName: '28474c55-5885-438a-b79c-da578f28f7ab',
      parentNodeId: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      parentName: '3ca3a8f7-e538-44f1-95c4-233458450aaf',
      childNodeIds: ['553fa76e-a498-4c79-9c9a-55f35200d99e'],
    },
  },
  {
    key: '39831087-3534-48ad-8bd9-7962eb6294d8',
    value: {
      nodeId: '39831087-3534-48ad-8bd9-7962eb6294d8',
      nodeName: '39831087-3534-48ad-8bd9-7962eb6294d8',
      parentNodeId: '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
    },
  },
  {
    key: 'aa582975-6261-4c0a-b145-5a6ccbab182b',
    value: {
      nodeId: 'aa582975-6261-4c0a-b145-5a6ccbab182b',
      nodeName: 'aa582975-6261-4c0a-b145-5a6ccbab182b',
      parentNodeId: '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
      parentName: '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
      childNodeIds: ['2e337345-58a1-4251-bed6-0d4c688b1136', '0bf97ede-6b30-44fd-b75c-075d93686aeb'],
    },
  },
  {
    key: '5cf7e563-c132-4671-a878-b5b38100fc72',
    value: {
      nodeId: '5cf7e563-c132-4671-a878-b5b38100fc72',
      nodeName: '5cf7e563-c132-4671-a878-b5b38100fc72',
      parentNodeId: '6b5182b3-7e3e-4a78-8c02-a96b0a8809f8',
    },
  },
  {
    key: '2e337345-58a1-4251-bed6-0d4c688b1136',
    value: {
      nodeId: '2e337345-58a1-4251-bed6-0d4c688b1136',
      nodeName: '2e337345-58a1-4251-bed6-0d4c688b1136',
      parentNodeId: 'aa582975-6261-4c0a-b145-5a6ccbab182b',
      parentName: 'aa582975-6261-4c0a-b145-5a6ccbab182b',
      childNodeIds: ['96d0acb6-68d3-4786-b78a-29179063c74c', '424c3a72-ab5d-4ff6-883c-0a883b1f1584'],
    },
  },
  {
    key: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
    value: {
      nodeId: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
      nodeName: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
      parentNodeId: 'aa582975-6261-4c0a-b145-5a6ccbab182b',
      parentName: 'aa582975-6261-4c0a-b145-5a6ccbab182b',
      childNodeIds: [
        '665d8429-1843-4366-a537-8c668807db1f',
        '484c81ce-0858-40dd-87c4-6184e1f62c1a',
        '9cf5987f-7b1c-4acb-a7bd-31d68e4f3d0d',
        'b97b54ce-0c03-4b4f-9daa-7fba655c80a8',
      ],
    },
  },
  {
    key: '665d8429-1843-4366-a537-8c668807db1f',
    value: {
      nodeId: '665d8429-1843-4366-a537-8c668807db1f',
      nodeName: '665d8429-1843-4366-a537-8c668807db1f',
      parentNodeId: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
      parentName: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
      childNodeIds: ['d66d14b3-9f1a-47a5-9fc6-912a3a93f1f2'],
    },
  },
  {
    key: '484c81ce-0858-40dd-87c4-6184e1f62c1a',
    value: {
      nodeId: '484c81ce-0858-40dd-87c4-6184e1f62c1a',
      nodeName: '484c81ce-0858-40dd-87c4-6184e1f62c1a',
      parentNodeId: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
      parentName: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
      childNodeIds: ['48f5d51b-4bb1-4901-9c81-69d938ce633a'],
    },
  },
  {
    key: '9cf5987f-7b1c-4acb-a7bd-31d68e4f3d0d',
    value: {
      nodeId: '9cf5987f-7b1c-4acb-a7bd-31d68e4f3d0d',
      nodeName: '9cf5987f-7b1c-4acb-a7bd-31d68e4f3d0d',
      parentNodeId: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
    },
  },
  {
    key: 'b97b54ce-0c03-4b4f-9daa-7fba655c80a8',
    value: {
      nodeId: 'b97b54ce-0c03-4b4f-9daa-7fba655c80a8',
      nodeName: 'b97b54ce-0c03-4b4f-9daa-7fba655c80a8',
      parentNodeId: '0bf97ede-6b30-44fd-b75c-075d93686aeb',
    },
  },
  {
    key: '553fa76e-a498-4c79-9c9a-55f35200d99e',
    value: {
      nodeId: '553fa76e-a498-4c79-9c9a-55f35200d99e',
      nodeName: '553fa76e-a498-4c79-9c9a-55f35200d99e',
      parentNodeId: '28474c55-5885-438a-b79c-da578f28f7ab',
    },
  },
  {
    key: '1db7ea52-303d-4174-b58a-10ab171c4bc4',
    value: {
      nodeId: '1db7ea52-303d-4174-b58a-10ab171c4bc4',
      nodeName: '1db7ea52-303d-4174-b58a-10ab171c4bc4',
      parentNodeId: '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
      parentName: '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
      childNodeIds: ['9aff9fbb-5c28-4b21-956b-e6b7fe14371f'],
    },
  },
  {
    key: '3c3c1e59-6988-4384-8a1b-23a0f0a17403',
    value: {
      nodeId: '3c3c1e59-6988-4384-8a1b-23a0f0a17403',
      nodeName: '3c3c1e59-6988-4384-8a1b-23a0f0a17403',
      parentNodeId: '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
    },
  },
  {
    key: 'caea1a5f-8c25-4c2a-8d76-21de4ea2bb6d',
    value: {
      nodeId: 'caea1a5f-8c25-4c2a-8d76-21de4ea2bb6d',
      nodeName: 'caea1a5f-8c25-4c2a-8d76-21de4ea2bb6d',
      parentNodeId: '55379a5d-88d2-4630-91d0-4fcf8a5bf097',
    },
  },
  {
    key: '9aff9fbb-5c28-4b21-956b-e6b7fe14371f',
    value: {
      nodeId: '9aff9fbb-5c28-4b21-956b-e6b7fe14371f',
      nodeName: '9aff9fbb-5c28-4b21-956b-e6b7fe14371f',
      parentNodeId: '1db7ea52-303d-4174-b58a-10ab171c4bc4',
      parentName: '1db7ea52-303d-4174-b58a-10ab171c4bc4',
      childNodeIds: ['5c24cd84-6491-40d3-9883-ba55f5d6b645', 'c6a0dac5-2bab-4574-a2a5-c60967ddb99c'],
    },
  },
  {
    key: '5c24cd84-6491-40d3-9883-ba55f5d6b645',
    value: {
      nodeId: '5c24cd84-6491-40d3-9883-ba55f5d6b645',
      nodeName: '5c24cd84-6491-40d3-9883-ba55f5d6b645',
      parentNodeId: '9aff9fbb-5c28-4b21-956b-e6b7fe14371f',
    },
  },
  {
    key: 'c6a0dac5-2bab-4574-a2a5-c60967ddb99c',
    value: {
      nodeId: 'c6a0dac5-2bab-4574-a2a5-c60967ddb99c',
      nodeName: 'c6a0dac5-2bab-4574-a2a5-c60967ddb99c',
      parentNodeId: '9aff9fbb-5c28-4b21-956b-e6b7fe14371f',
    },
  },
  {
    key: '48f5d51b-4bb1-4901-9c81-69d938ce633a',
    value: {
      nodeId: '48f5d51b-4bb1-4901-9c81-69d938ce633a',
      nodeName: '48f5d51b-4bb1-4901-9c81-69d938ce633a',
      parentNodeId: '484c81ce-0858-40dd-87c4-6184e1f62c1a',
      parentName: '484c81ce-0858-40dd-87c4-6184e1f62c1a',
      childNodeIds: ['2b1d5efe-a42e-4774-b845-87fe3da2d660', 'f7aa0a9f-ab30-4b25-ba92-89047eadff7d'],
    },
  },
  {
    key: '2b1d5efe-a42e-4774-b845-87fe3da2d660',
    value: {
      nodeId: '2b1d5efe-a42e-4774-b845-87fe3da2d660',
      nodeName: '2b1d5efe-a42e-4774-b845-87fe3da2d660',
      parentNodeId: '48f5d51b-4bb1-4901-9c81-69d938ce633a',
    },
  },
  {
    key: 'f7aa0a9f-ab30-4b25-ba92-89047eadff7d',
    value: {
      nodeId: 'f7aa0a9f-ab30-4b25-ba92-89047eadff7d',
      nodeName: 'f7aa0a9f-ab30-4b25-ba92-89047eadff7d',
      parentNodeId: '48f5d51b-4bb1-4901-9c81-69d938ce633a',
    },
  },
  {
    key: '96d0acb6-68d3-4786-b78a-29179063c74c',
    value: {
      nodeId: '96d0acb6-68d3-4786-b78a-29179063c74c',
      nodeName: '96d0acb6-68d3-4786-b78a-29179063c74c',
      parentNodeId: '2e337345-58a1-4251-bed6-0d4c688b1136',
    },
  },
  {
    key: '424c3a72-ab5d-4ff6-883c-0a883b1f1584',
    value: {
      nodeId: '424c3a72-ab5d-4ff6-883c-0a883b1f1584',
      nodeName: '424c3a72-ab5d-4ff6-883c-0a883b1f1584',
      parentNodeId: '2e337345-58a1-4251-bed6-0d4c688b1136',
      parentName: '2e337345-58a1-4251-bed6-0d4c688b1136',
      childNodeIds: ['2f42e467-25d5-4d39-9a65-32266ba98493'],
    },
  },
  {
    key: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
    value: {
      nodeId: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
      nodeName: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
      parentNodeId: '665d8429-1843-4366-a537-8c668807db1f',
      parentName: '665d8429-1843-4366-a537-8c668807db1f',
      childNodeIds: [
        'eff8bfc7-1781-4019-b4f9-b5e90db3c823',
        '2a135911-ee36-42c4-b0e3-f46df17a1b79',
        '18a60225-eab5-4c02-8776-b119269ce265',
      ],
    },
  },
  {
    key: '64575861-653f-448e-93f3-2e52fa17564f',
    value: {
      nodeId: '64575861-653f-448e-93f3-2e52fa17564f',
      nodeName: '64575861-653f-448e-93f3-2e52fa17564f',
      parentNodeId: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
    },
  },
  {
    key: 'eff8bfc7-1781-4019-b4f9-b5e90db3c823',
    value: {
      nodeId: 'eff8bfc7-1781-4019-b4f9-b5e90db3c823',
      nodeName: 'eff8bfc7-1781-4019-b4f9-b5e90db3c823',
      parentNodeId: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
    },
  },
  {
    key: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
    value: {
      nodeId: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
      nodeName: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
      parentNodeId: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
      parentName: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
      childNodeIds: [
        'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
        'a4b1173a-f3c9-45a2-99db-7a947d79c999',
        '305cbe8a-ee4f-4fec-b2cc-2ca3ea1b8ff0',
      ],
    },
  },
  {
    key: '18a60225-eab5-4c02-8776-b119269ce265',
    value: {
      nodeId: '18a60225-eab5-4c02-8776-b119269ce265',
      nodeName: '18a60225-eab5-4c02-8776-b119269ce265',
      parentNodeId: 'd66d14b3-9f1a-47a5-9fc6-912a3a93f1f2',
    },
  },
  {
    key: 'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
    value: {
      nodeId: 'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
      nodeName: 'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
      parentNodeId: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
      parentName: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
      childNodeIds: [
        '0d5eee50-e026-49cd-b159-37c70d9e1842',
        '197b9a13-5384-4855-9b07-97557b452df6',
        '5c49fae1-ca3e-4acb-8d65-5614d0e4b791',
      ],
    },
  },
  {
    key: 'a4b1173a-f3c9-45a2-99db-7a947d79c999',
    value: {
      nodeId: 'a4b1173a-f3c9-45a2-99db-7a947d79c999',
      nodeName: 'a4b1173a-f3c9-45a2-99db-7a947d79c999',
      parentNodeId: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
      parentName: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
      childNodeIds: ['23b1488b-533c-4ceb-b543-50f4266964f1'],
    },
  },
  {
    key: '305cbe8a-ee4f-4fec-b2cc-2ca3ea1b8ff0',
    value: {
      nodeId: '305cbe8a-ee4f-4fec-b2cc-2ca3ea1b8ff0',
      nodeName: '305cbe8a-ee4f-4fec-b2cc-2ca3ea1b8ff0',
      parentNodeId: '2a135911-ee36-42c4-b0e3-f46df17a1b79',
    },
  },
  {
    key: '23b1488b-533c-4ceb-b543-50f4266964f1',
    value: {
      nodeId: '23b1488b-533c-4ceb-b543-50f4266964f1',
      nodeName: '23b1488b-533c-4ceb-b543-50f4266964f1',
      parentNodeId: 'a4b1173a-f3c9-45a2-99db-7a947d79c999',
      parentName: 'a4b1173a-f3c9-45a2-99db-7a947d79c999',
      childNodeIds: ['6e708325-3c13-48a0-9731-37b4188b684e', '6cc06cfe-39b4-49b1-9c4a-94983d9cd67c'],
    },
  },
  {
    key: '6e708325-3c13-48a0-9731-37b4188b684e',
    value: {
      nodeId: '6e708325-3c13-48a0-9731-37b4188b684e',
      nodeName: '6e708325-3c13-48a0-9731-37b4188b684e',
      parentNodeId: '23b1488b-533c-4ceb-b543-50f4266964f1',
    },
  },
  {
    key: '6cc06cfe-39b4-49b1-9c4a-94983d9cd67c',
    value: {
      nodeId: '6cc06cfe-39b4-49b1-9c4a-94983d9cd67c',
      nodeName: '6cc06cfe-39b4-49b1-9c4a-94983d9cd67c',
      parentNodeId: '23b1488b-533c-4ceb-b543-50f4266964f1',
    },
  },
  {
    key: '13a7e56d-85f4-4526-b4f5-47fa0eef2e9f',
    value: {
      nodeId: '13a7e56d-85f4-4526-b4f5-47fa0eef2e9f',
      nodeName: '13a7e56d-85f4-4526-b4f5-47fa0eef2e9f',
      parentNodeId: 'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
    },
  },
  {
    key: '0d5eee50-e026-49cd-b159-37c70d9e1842',
    value: {
      nodeId: '0d5eee50-e026-49cd-b159-37c70d9e1842',
      nodeName: '0d5eee50-e026-49cd-b159-37c70d9e1842',
      parentNodeId: 'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
    },
  },
  {
    key: '197b9a13-5384-4855-9b07-97557b452df6',
    value: {
      nodeId: '197b9a13-5384-4855-9b07-97557b452df6',
      nodeName: '197b9a13-5384-4855-9b07-97557b452df6',
      parentNodeId: 'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
    },
  },
  {
    key: '5c49fae1-ca3e-4acb-8d65-5614d0e4b791',
    value: {
      nodeId: '5c49fae1-ca3e-4acb-8d65-5614d0e4b791',
      nodeName: '5c49fae1-ca3e-4acb-8d65-5614d0e4b791',
      parentNodeId: 'fcc64f90-c841-448d-a50f-c0f1a85b4bc4',
    },
  },
  {
    key: '8946e96d-7e64-4228-b5f5-25823cac5e23',
    value: {
      nodeId: '8946e96d-7e64-4228-b5f5-25823cac5e23',
      nodeName: '8946e96d-7e64-4228-b5f5-25823cac5e23',
      parentNodeId: '424c3a72-ab5d-4ff6-883c-0a883b1f1584',
    },
  },
  {
    key: '2f42e467-25d5-4d39-9a65-32266ba98493',
    value: {
      nodeId: '2f42e467-25d5-4d39-9a65-32266ba98493',
      nodeName: '2f42e467-25d5-4d39-9a65-32266ba98493',
      parentNodeId: '424c3a72-ab5d-4ff6-883c-0a883b1f1584',
    },
  },
  {
    key: 'f2fadd68-87f6-468e-b3fa-5fc7bb1bbae2',
    value: {
      nodeId: 'f2fadd68-87f6-468e-b3fa-5fc7bb1bbae2',
      nodeName: 'f2fadd68-87f6-468e-b3fa-5fc7bb1bbae2',
      parentNodeId: 'test-1',
      parentName: 'Test 1',
      childNodeIds: ['8ea09f41-625d-4a3b-8d3e-f45a40c0cf22', 'ecf7c993-d95d-4b40-9f46-35ef1587b076'],
    },
  },
  {
    key: '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
    value: {
      nodeId: '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
      nodeName: '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
      parentNodeId: 'test-1',
      parentName: 'Test 1',
      childNodeIds: ['aebf2fd2-75c0-4296-904d-af72aabecabb', '69a10ac3-cdd1-4711-831a-d44607d0eb19'],
    },
  },
  {
    key: '28303b05-b7d1-4155-a45c-6307c2b4ccc1',
    value: {
      nodeId: '28303b05-b7d1-4155-a45c-6307c2b4ccc1',
      nodeName: '28303b05-b7d1-4155-a45c-6307c2b4ccc1',
      parentNodeId: 'test-1',
    },
  },
  {
    key: '0bdbf4e2-e026-438c-b76b-22f89df11404',
    value: {
      nodeId: '0bdbf4e2-e026-438c-b76b-22f89df11404',
      nodeName: '0bdbf4e2-e026-438c-b76b-22f89df11404',
      parentNodeId: '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
    },
  },
  {
    key: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
    value: {
      nodeId: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
      nodeName: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
      parentNodeId: '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
      parentName: '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
      childNodeIds: [
        '0ac715fd-ac6c-49c2-ab9e-5a6c588c355a',
        'b86cd5d0-0433-4658-b082-fe5027178892',
        '29ee6a7d-cfaf-483b-83cf-8f1ede7d0f07',
      ],
    },
  },
  {
    key: '69a10ac3-cdd1-4711-831a-d44607d0eb19',
    value: {
      nodeId: '69a10ac3-cdd1-4711-831a-d44607d0eb19',
      nodeName: '69a10ac3-cdd1-4711-831a-d44607d0eb19',
      parentNodeId: '7bbf0ec9-cfd3-457d-8a23-1a0db1057123',
    },
  },
  {
    key: '0ac715fd-ac6c-49c2-ab9e-5a6c588c355a',
    value: {
      nodeId: '0ac715fd-ac6c-49c2-ab9e-5a6c588c355a',
      nodeName: '0ac715fd-ac6c-49c2-ab9e-5a6c588c355a',
      parentNodeId: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
      parentName: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
      childNodeIds: ['692176f0-2c44-428c-9839-4bd9021002ee'],
    },
  },
  {
    key: 'b86cd5d0-0433-4658-b082-fe5027178892',
    value: {
      nodeId: 'b86cd5d0-0433-4658-b082-fe5027178892',
      nodeName: 'b86cd5d0-0433-4658-b082-fe5027178892',
      parentNodeId: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
      parentName: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
      childNodeIds: [
        '50c91d89-36d7-4281-997a-1f4dddfe2641',
        '1bbaa076-3813-4a3e-8464-f23b72edd661',
        '07b5c384-e0f3-4ff4-b6a2-11ae5fc2f24b',
        'c856dcfb-0fd9-4cf9-9932-f714e8e7ba34',
      ],
    },
  },
  {
    key: '29ee6a7d-cfaf-483b-83cf-8f1ede7d0f07',
    value: {
      nodeId: '29ee6a7d-cfaf-483b-83cf-8f1ede7d0f07',
      nodeName: '29ee6a7d-cfaf-483b-83cf-8f1ede7d0f07',
      parentNodeId: 'aebf2fd2-75c0-4296-904d-af72aabecabb',
    },
  },
  {
    key: '50c91d89-36d7-4281-997a-1f4dddfe2641',
    value: {
      nodeId: '50c91d89-36d7-4281-997a-1f4dddfe2641',
      nodeName: '50c91d89-36d7-4281-997a-1f4dddfe2641',
      parentNodeId: 'b86cd5d0-0433-4658-b082-fe5027178892',
    },
  },
  {
    key: '1bbaa076-3813-4a3e-8464-f23b72edd661',
    value: {
      nodeId: '1bbaa076-3813-4a3e-8464-f23b72edd661',
      nodeName: '1bbaa076-3813-4a3e-8464-f23b72edd661',
      parentNodeId: 'b86cd5d0-0433-4658-b082-fe5027178892',
    },
  },
  {
    key: '07b5c384-e0f3-4ff4-b6a2-11ae5fc2f24b',
    value: {
      nodeId: '07b5c384-e0f3-4ff4-b6a2-11ae5fc2f24b',
      nodeName: '07b5c384-e0f3-4ff4-b6a2-11ae5fc2f24b',
      parentNodeId: 'b86cd5d0-0433-4658-b082-fe5027178892',
    },
  },
  {
    key: 'c856dcfb-0fd9-4cf9-9932-f714e8e7ba34',
    value: {
      nodeId: 'c856dcfb-0fd9-4cf9-9932-f714e8e7ba34',
      nodeName: 'c856dcfb-0fd9-4cf9-9932-f714e8e7ba34',
      parentNodeId: 'b86cd5d0-0433-4658-b082-fe5027178892',
    },
  },
  {
    key: 'c32f8ead-f3ff-4331-ac05-961e7c926e4e',
    value: {
      nodeId: 'c32f8ead-f3ff-4331-ac05-961e7c926e4e',
      nodeName: 'c32f8ead-f3ff-4331-ac05-961e7c926e4e',
      parentNodeId: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
    },
  },
  {
    key: '1bd0212f-a53a-4908-853a-c369a4d1fac4',
    value: {
      nodeId: '1bd0212f-a53a-4908-853a-c369a4d1fac4',
      nodeName: '1bd0212f-a53a-4908-853a-c369a4d1fac4',
      parentNodeId: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
      parentName: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
      childNodeIds: [
        '5f6708ed-5b17-4f34-95e3-ced9f12d0e24',
        'fe50fe15-6633-47ab-8909-ccb8b9bae6e4',
        'de08ed2a-1d12-4c02-8f52-a1cabf7c3f0f',
      ],
    },
  },
  {
    key: 'd1db0887-ba1c-4294-b096-76c721a6fec0',
    value: {
      nodeId: 'd1db0887-ba1c-4294-b096-76c721a6fec0',
      nodeName: 'd1db0887-ba1c-4294-b096-76c721a6fec0',
      parentNodeId: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
      parentName: '7dc881a6-55d2-4b1f-ae4e-a82ebf24a109',
      childNodeIds: ['3ed9231f-9281-4e65-a330-0107d3c3e413', '915bb79e-b784-4d7c-bb50-f24b415075b2'],
    },
  },
  {
    key: '692176f0-2c44-428c-9839-4bd9021002ee',
    value: {
      nodeId: '692176f0-2c44-428c-9839-4bd9021002ee',
      nodeName: '692176f0-2c44-428c-9839-4bd9021002ee',
      parentNodeId: '0ac715fd-ac6c-49c2-ab9e-5a6c588c355a',
      parentName: '0ac715fd-ac6c-49c2-ab9e-5a6c588c355a',
      childNodeIds: [
        '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
        '3ff6da6d-bba5-4e82-ba0d-b8d3ec4bfa3b',
        '64d7544d-82b8-4eab-a5dc-35c96cabd83b',
      ],
    },
  },
  {
    key: 'ec74a354-b290-4e87-960a-f0bedad6e976',
    value: {
      nodeId: 'ec74a354-b290-4e87-960a-f0bedad6e976',
      nodeName: 'ec74a354-b290-4e87-960a-f0bedad6e976',
      parentNodeId: '692176f0-2c44-428c-9839-4bd9021002ee',
    },
  },
  {
    key: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
    value: {
      nodeId: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
      nodeName: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
      parentNodeId: '692176f0-2c44-428c-9839-4bd9021002ee',
      parentName: '692176f0-2c44-428c-9839-4bd9021002ee',
      childNodeIds: [
        '046566f8-7fe0-4f1e-a667-6e384acc9c26',
        'edc6408e-5169-4c0d-9bbc-f140c9c5cff0',
        '71f51e5f-0120-41d1-adcd-f44b4f7df2f4',
        'cd013417-1222-4f67-9568-74300606fdfe',
      ],
    },
  },
  {
    key: '3ff6da6d-bba5-4e82-ba0d-b8d3ec4bfa3b',
    value: {
      nodeId: '3ff6da6d-bba5-4e82-ba0d-b8d3ec4bfa3b',
      nodeName: '3ff6da6d-bba5-4e82-ba0d-b8d3ec4bfa3b',
      parentNodeId: '692176f0-2c44-428c-9839-4bd9021002ee',
    },
  },
  {
    key: '64d7544d-82b8-4eab-a5dc-35c96cabd83b',
    value: {
      nodeId: '64d7544d-82b8-4eab-a5dc-35c96cabd83b',
      nodeName: '64d7544d-82b8-4eab-a5dc-35c96cabd83b',
      parentNodeId: '692176f0-2c44-428c-9839-4bd9021002ee',
    },
  },
  {
    key: '9697d882-3a03-407d-91f2-2a1036ed01a5',
    value: {
      nodeId: '9697d882-3a03-407d-91f2-2a1036ed01a5',
      nodeName: '9697d882-3a03-407d-91f2-2a1036ed01a5',
      parentNodeId: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
    },
  },
  {
    key: '32d6a551-8532-40bd-b1b7-a456b2f95f32',
    value: {
      nodeId: '32d6a551-8532-40bd-b1b7-a456b2f95f32',
      nodeName: '32d6a551-8532-40bd-b1b7-a456b2f95f32',
      parentNodeId: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
    },
  },
  {
    key: '046566f8-7fe0-4f1e-a667-6e384acc9c26',
    value: {
      nodeId: '046566f8-7fe0-4f1e-a667-6e384acc9c26',
      nodeName: '046566f8-7fe0-4f1e-a667-6e384acc9c26',
      parentNodeId: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
      parentName: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
    },
  },
  {
    key: 'edc6408e-5169-4c0d-9bbc-f140c9c5cff0',
    value: {
      nodeId: 'edc6408e-5169-4c0d-9bbc-f140c9c5cff0',
      nodeName: 'edc6408e-5169-4c0d-9bbc-f140c9c5cff0',
      parentNodeId: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
    },
  },
  {
    key: '71f51e5f-0120-41d1-adcd-f44b4f7df2f4',
    value: {
      nodeId: '71f51e5f-0120-41d1-adcd-f44b4f7df2f4',
      nodeName: '71f51e5f-0120-41d1-adcd-f44b4f7df2f4',
      parentNodeId: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
    },
  },
  {
    key: 'cd013417-1222-4f67-9568-74300606fdfe',
    value: {
      nodeId: 'cd013417-1222-4f67-9568-74300606fdfe',
      nodeName: 'cd013417-1222-4f67-9568-74300606fdfe',
      parentNodeId: '577b2d1f-7b0a-4ad3-814d-3ed728faa58d',
    },
  },
  {
    key: '32098ec2-da92-457b-9ace-fb5e437ec7cd',
    value: {
      nodeId: '32098ec2-da92-457b-9ace-fb5e437ec7cd',
      nodeName: '32098ec2-da92-457b-9ace-fb5e437ec7cd',
      parentNodeId: 'f2fadd68-87f6-468e-b3fa-5fc7bb1bbae2',
    },
  },
  {
    key: '8ea09f41-625d-4a3b-8d3e-f45a40c0cf22',
    value: {
      nodeId: '8ea09f41-625d-4a3b-8d3e-f45a40c0cf22',
      nodeName: '8ea09f41-625d-4a3b-8d3e-f45a40c0cf22',
      parentNodeId: 'f2fadd68-87f6-468e-b3fa-5fc7bb1bbae2',
    },
  },
  {
    key: 'ecf7c993-d95d-4b40-9f46-35ef1587b076',
    value: {
      nodeId: 'ecf7c993-d95d-4b40-9f46-35ef1587b076',
      nodeName: 'ecf7c993-d95d-4b40-9f46-35ef1587b076',
      parentNodeId: 'f2fadd68-87f6-468e-b3fa-5fc7bb1bbae2',
    },
  },
  {
    key: '3ed9231f-9281-4e65-a330-0107d3c3e413',
    value: {
      nodeId: '3ed9231f-9281-4e65-a330-0107d3c3e413',
      nodeName: '3ed9231f-9281-4e65-a330-0107d3c3e413',
      parentNodeId: 'd1db0887-ba1c-4294-b096-76c721a6fec0',
    },
  },
  {
    key: '915bb79e-b784-4d7c-bb50-f24b415075b2',
    value: {
      nodeId: '915bb79e-b784-4d7c-bb50-f24b415075b2',
      nodeName: '915bb79e-b784-4d7c-bb50-f24b415075b2',
      parentNodeId: 'd1db0887-ba1c-4294-b096-76c721a6fec0',
    },
  },
  {
    key: '5f6708ed-5b17-4f34-95e3-ced9f12d0e24',
    value: {
      nodeId: '5f6708ed-5b17-4f34-95e3-ced9f12d0e24',
      nodeName: '5f6708ed-5b17-4f34-95e3-ced9f12d0e24',
      parentNodeId: '1bd0212f-a53a-4908-853a-c369a4d1fac4',
    },
  },
  {
    key: 'fe50fe15-6633-47ab-8909-ccb8b9bae6e4',
    value: {
      nodeId: 'fe50fe15-6633-47ab-8909-ccb8b9bae6e4',
      nodeName: 'fe50fe15-6633-47ab-8909-ccb8b9bae6e4',
      parentNodeId: '1bd0212f-a53a-4908-853a-c369a4d1fac4',
    },
  },
  {
    key: 'de08ed2a-1d12-4c02-8f52-a1cabf7c3f0f',
    value: {
      nodeId: 'de08ed2a-1d12-4c02-8f52-a1cabf7c3f0f',
      nodeName: 'de08ed2a-1d12-4c02-8f52-a1cabf7c3f0f',
      parentNodeId: '1bd0212f-a53a-4908-853a-c369a4d1fac4',
    },
  },
];

export const staticNodesWithCheckboxAndIcons: Array<StaticNode> = [
  {
    nodeId: 'bitdefender',
    nodeName: 'Bitdefender',
    icon: 'ds-icon-menu_network',
    isOpen: true,
    childNodes: [
      {
        nodeId: v4(),
        nodeName: 'Test 1',
        icon: 'ds-icon-MacOS',
        noCheckbox: true,
        childNodes: [
          {
            nodeId: v4(),
            nodeName: 'Test 1 - 1',
          },
          {
            nodeId: v4(),
            nodeName: 'Test 1 - 2',
          },
        ],
      },
      {
        nodeId: v4(),
        nodeName: 'Test 2',
        icon: 'ds-icon-menu_network',
        childNodes: [
          {
            nodeId: v4(),
            nodeName: 'Test 2 - 1',
            childNodes: [
              {
                nodeId: v4(),
                nodeName: 'Test 2-2-1',
                childNodes: [
                  {
                    nodeId: v4(),
                    nodeName: 'Test 2-3-1',
                  },
                  {
                    nodeId: v4(),
                    nodeName: 'Test 2-3-2',
                  },
                ],
              },
            ],
          },
          {
            nodeId: v4(),
            nodeName: 'Test 2 - 2',
          },
        ],
      },
    ],
  },
];
